<!-- Templete  -->
<template> 
    <draggable v-bind="dragOptions" :emptyInsertThreshold="500"  :disabled="!enabled" class="list-group" ghost-class="ghost"   @start="dragging = true" @end="dragging = false">
    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
      <Article0004 v-for="(article, index) in articleList" v-bind:key="index" v-bind:articleId="article.article_id" v-bind:articleTitle="article.article_title" v-bind:articleCategory="article.media_name" v-bind:articleDate="article.issue_date" v-bind:articlePages="article.issue_type" v-bind:articleSearchTerm="article.search_word" v-bind:articleComment="article.article_comment" v-bind:articleImage="article.articleImage" v-bind:articleDataSection="article.data_section"/>
    </transition-group>
    </draggable>
</template>

<!-- Script  -->
<script>
 import draggable from 'vuedraggable';
 import Article0004 from './Article0004.vue';
export default {
    name: "simple",
    display: "Transitions",
    order: 3,
    props: {
      drag: Boolean,
      articleList: Array
    },
    components: {
      draggable,
      Article0004,	
    },
  data() {
    return {
      // enabled: true, in the below line for dragging 
      enabled: false,
      dragging: false
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
}
</script>
<style>
.flip-list-move {
  transition: transform 0.5s;
}

label {
  font-size: 8pt;
  padding-left: 6px;
}

.el-checkbox {
  margin-right: 0px !important;
}
</style>
